module.exports = __webpack_public_path__ + "6d41bdfbe53b4323335f628fa019b4a5.svg";